import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';

import {
    ActionsColumn,
    ConversationColumn,
    IdColumn,
    MessageContentColumn,
    NumberColumn,
    SentimentColumn,
    UserRatingColumn,
} from './columns';
import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import {
    useDebouncedCallback,
    useDisclosure,
    useLocalStorage,
} from '@mantine/hooks';
import { useMemo, useState } from 'react';

import ConversationViewModal from '../modals/ConversationViewModal';
import FiltersMultiSelect from '../../../common/filtersMultiSelect/FiltersMultiSelect';
import { MantineReactTable } from 'mantine-react-table';
import { MultiSelectCreatable } from '../../../common';
import { getMessages } from '../../../../http/apiClient';
import { usePaginatedQuery } from '../../../../http/queries/usePaginatedQuery';

const MessageListView = ({ ...props }) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 100,
    });

    const filterDebounce = useDebouncedCallback((query) => {
        setGlobalFilter(query);
    }, 600);

    const {
        isLoading,
        isError,
        error,
        data: paginatedData,
    } = usePaginatedQuery({
        queryFn: (queryParams) => getMessages(queryParams),
        queryKey: ['messages'],
        refetchInterval: 15_0000,
        globalFilter,
        pagination,
        sorting,
    });

    const [
        conversationModalOpen,
        { open: openConversationModal, close: closeConversationModal },
    ] = useDisclosure();

    const [modalConversation, setModalConversation] = useState(null);

    const { data: messages, pagination: dataPagination } = paginatedData || {};
    const columns = useMemo(
        () => [
            IdColumn(),
            ConversationColumn(),
            NumberColumn(),
            MessageContentColumn(),
            UserRatingColumn(),
            SentimentColumn(),
        ],
        [messages]
    );

    /*const tableData = useMemo(
        () => (isLoading ? [] : campaigns),
        [campaigns, isLoading]
    );*/

    const tableData = useMemo(
        () => (isLoading ? [] : messages),
        [messages, isLoading]
    );

    const [columnVisibility, setColumnVisibility] = useLocalStorage({
        key: 'messages-table-visibility', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const [columnSizing, setColumnSizing] = useLocalStorage({
        key: 'messages-group-table-sizing', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const handleVisibilityChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnVisibility((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handlSizeChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnSizing((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handleFilterChange = (queryStr) => {
        filterDebounce(queryStr);
    };

    const tableProps = {
        columns: columns,
        data: tableData,
        enableRowActions: true,
        enableColumnResizing: true,
        enableColumnActions: false,
        enableSorting: false,
        enableTopToolbar: true,
        enableGlobalFilter: true,
        enableFilters: false,
        enableStickyHeader: true,
        enableDensityToggle: false,
        positionActionsColumn: 'last',
        layoutMode: 'semantic',
        mantineSearchTextInputProps: {
            placeholder: 'Search Messages',
            miw: 200,
        },
        mantineTableContainerProps: {
            style: {
                minHeight: '80vh',
            },
        },
        positionGlobalFilter: 'left',
        renderTopToolbarCustomActions: () => (
            <Box
                w={'100%'}
                px={'lg'}>
                <FiltersMultiSelect
                    options={[{ label: 'test', value: 'test' }]}
                />
            </Box>
        ),
        renderRowActions: (props) => (
            <ActionsColumn
                {...props}
                setModalItem={setModalConversation}
                openConversationModal={openConversationModal}
            />
        ),

        manualPagination: true,
        manualSorting: true,
        onColumnVisibilityChange: handleVisibilityChange,
        onColumnSizingChange: handlSizeChange,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onGlobalFilterChange: handleFilterChange,
        rowCount: dataPagination?.totalItems || 0,
        pageCount: dataPagination?.totalPages || 1,

        initialState: {
            columnVisibility,
            pagination,
            isLoading,
            showGlobalFilter: true,
        },
        state: {
            isLoading,
            pagination,
            columnVisibility,
            columnSizing,
            showAlertBanner: isError,
            showProgressBars: isLoading,
            sorting,
            density: 'xs',
        },
    };

    return (
        <Container fluid>
            <MantineReactTable {...tableProps} />
            <ConversationViewModal
                conversationId={modalConversation?.conversationId}
                opened={conversationModalOpen}
                close={closeConversationModal}
            />
        </Container>
    );
};
export default MessageListView;
